import React from 'react';
import { Switch, Tooltip, Space, Typography } from 'antd';
import { ShopOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import type { RootState } from '../../store/store';

const { Text } = Typography;

interface StoreWithStatus {
  id: string;
  name: string;
  latitude: number;
  longitude: number;
  mapsUrl?: string;
  isOpenForOrders?: boolean;
}

interface StoreStatusToggleWidgetProps {
  isMobile?: boolean;
}

export const StoreStatusToggleWidget: React.FC<StoreStatusToggleWidgetProps> = ({
  isMobile = false,
}) => {
  const activeStoreId = useSelector((state: RootState) => state.auth.activeStoreId);
  const allowedStores = useSelector(
    (state: RootState) => state.auth.allowedStores
  ) as StoreWithStatus[];
  const partner = useSelector((state: RootState) => state.auth.partner);

  const activeStore = allowedStores.find((s) => s.id === activeStoreId);
  const isOpen = activeStore?.isOpenForOrders ?? true;

  if (!activeStoreId || !partner) return null;

  return (
    <Tooltip
      title={
        isOpen ? 'Sucursal abierta - Click para cerrar' : 'Sucursal cerrada - Click para abrir'
      }
      placement="bottom"
    >
      <Space align="center" style={{ gap: 8 }}>
        <ShopOutlined style={{ fontSize: 16, color: isOpen ? '#52c41a' : '#ff4d4f' }} />
        {!isMobile && (
          <Text strong style={{ fontSize: 13, color: isOpen ? '#52c41a' : '#ff4d4f' }}>
            {isOpen ? 'Abierta' : 'Cerrada'}
          </Text>
        )}
        <Switch
          checked={isOpen}
          onChange={() => {}}
          size="small"
          checkedChildren="Abierta"
          unCheckedChildren="Cerrada"
          style={{ width: 70 }}
        />
      </Space>
    </Tooltip>
  );
};

export default StoreStatusToggleWidget;
